import { I18n } from '@calendly/i18n';
import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetUserQuery } from 'common';
import { WandIcon } from 'features/header';
import { useTrack } from 'hooks/analytics_events';
import { useFetchTrackedMeetingWithSummariesByForeignIdQuery } from 'hooks/tracked_meetings/api';
import { WidgetContainer } from '../widgets/widget_container';
const titleCss = "t1hkucqj";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const containerCss = "cgaolz0";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const iconContainerCss = "i14idlxb";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const inProgressWrapperCss = "in3vjmt";
const InProgressWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inProgressWrapperCss, props.className)} />;
});
const Content = ({
  isPretending,
  summary,
  isRecapInProgress
}) => {
  if (isRecapInProgress) {
    return <InProgressWrapper>
        <BodyText weight="bold" size="large">
          {I18n.t('publisher.meetings.notetaker.progress_header')}
        </BodyText>
        <BodyText size="medium" color="muted">
          {I18n.t('publisher.meetings.notetaker.in_progress')}
        </BodyText>
      </InProgressWrapper>;
  }
  if (!summary || isEmpty(summary)) {
    return <BodyText size="medium" color="muted">
        {I18n.t('publisher.meetings.notetaker.cannot_view')}
      </BodyText>;
  }
  if (isPretending) {
    return <BodyText size="medium" color="muted">
        {I18n.t('publisher.meeting_intelligence.scheduled_event.pretend_mode')}
      </BodyText>;
  }
  return <BodyText size="medium">
      {summary}
    </BodyText>;
};
export const AiNotes = ({
  event
}) => {
  const history = useHistory();
  const {
    data: currentUser
  } = useGetUserQuery();
  const isMiCompleted = event?.meetingIntelligence?.status?.toLowerCase() === 'completed';
  const isRecapInProgress = ['meetingended', 'summarizing'].includes(event?.meetingIntelligence?.status?.toLowerCase()?.replace('_', ''));
  const trackedMeetingUuid = event.meetingIntelligence?.uuid;
  const {
    data: trackedMeeting
  } = useFetchTrackedMeetingWithSummariesByForeignIdQuery(event.uuid, {
    skip: !event || !isMiCompleted
  });
  const track = useTrack();
  const isPretending = !currentUser || currentUser.is_pretending;
  const url = `/app/tracked_meetings/${trackedMeetingUuid}`;
  const handleClick = e => {
    track({
      name: 'CTA Clicked',
      properties: {
        cta_key: 'meetings_page_right_rail_notes',
        cta_text: 'view_recap',
        action: 'view_recap',
        cta_destination: 'meeting_recap',
        event_uuid: event.uuid,
        mi_event_uuid: trackedMeetingUuid
      }
    });
    history.push(url);
  };
  if (!trackedMeetingUuid || !isMiCompleted && !isRecapInProgress) return null;
  return <WidgetContainer title={<Title>
          <IconContainer>
            <WandIcon />
          </IconContainer>
          {I18n.t('publisher.meetings.notetaker.notes')}
        </Title>}>
      <Container>
        <Content isPretending={isPretending} summary={trackedMeeting?.summary} isRecapInProgress={isRecapInProgress} />
        {!isPretending && !isRecapInProgress && <BodyText>
            <Link as="button" onClick={handleClick} underline={false}>
              {I18n.t('publisher.meetings.notetaker.view_recap')}
              <ArrowExpandIcon />
            </Link>
          </BodyText>}
      </Container>
    </WidgetContainer>;
};

require("./ai_notes.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ai_notes.js");